module.exports = __webpack_public_path__ + "media/TOSOLA_deduction.5e9d7799.webm";